<ng-container *ngIf="formData" [formGroup]="formData">
  <p-multiSelect
    [filter]="filter"
    [filterBy]="filterBy"
    [options]="options"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    [showToggleAll]="showToggleAll"
    [resetFilterOnHide]="resetFilterOnHide"
    [id]="muFormControlName"
    [name]="muFormControlName"
    [formControlName]="muFormControlName"
  >
    <ng-template let-items pTemplate="selectedItems">
      <span *ngIf="!items || items.length === 0">{{ getPlaceHolder() | translate }}</span>
      <span *ngIf="items && items.length === 1">{{ getLabelById(items[0]?.value) }} </span>
      <span *ngIf="items && items.length > 1">{{
        getManySelectedLabel() | translate : { size: items.length }
      }}</span>
    </ng-template>
    <ng-template pTemplate="item" let-item>
      <div class="status-info mu-dropdown-item">{{ item.label }}</div>
    </ng-template>
  </p-multiSelect>
</ng-container>
<p-multiSelect
  *ngIf="!formData"
  [filter]="filter"
  [filterBy]="filterBy"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [options]="options"
  [showToggleAll]="showToggleAll"
  [(ngModel)]="filterList.model[filterName]"
  [resetFilterOnHide]="resetFilterOnHide"
>
  <ng-template let-items pTemplate="selectedItems">
    <span *ngIf="!items || items.length === 0">{{ getPlaceHolder() | translate }}</span>
    <span *ngIf="items && items.length === 1">{{ getLabelById(items[0]?.value) }}</span>
    <span *ngIf="items && items.length > 1">{{
      getManySelectedLabel() | translate : { size: items.length }
    }}</span>
  </ng-template>
  <ng-template pTemplate="item" let-item>
    <div class="status-info mu-dropdown-item">{{ item.label }}</div>
  </ng-template>
</p-multiSelect>
